import BaseDrawer from '@/utils/map/BaseDrawer'
import { OBJECT } from '@/utils/map/types'
import L from 'leaflet'
import { COLORS } from '@/utils'
import region from '@/utils/region'
import { TATARSTAN } from '@/config/region'
import { REGION_CONFIG } from '@/config/regions'

export default class MappingDrawer extends BaseDrawer {
  _polyData = []
  _polyLegend = {}
  _polygons = {}
  _polyId = null
  _relatedObjects = null
  _relations = null
  _relatedObjectsPoly = {}
  _commonRelatedObjects = {}

  setPolyData(data = [], legend = {}, id) {
    this.clearPoly()
    this._polyData = data
    this._polyLegend = this.dropVueWatchers(legend)
    this._polyId = id || +new Date()
    this.drawPoly()
  }

  setRelatedObjects(objects) {
    this._relatedObjects = objects
  }

  setRelations(relations) {
    this._relations = relations
  }

  isPolyDrawed(id) {
    return this._polyId === id
  }

  clearPoly() {
    for (let key in this._polygons) {
      this._polygons[key].remove()
    }
    this._polyLegend = {}
    this._polyId = null
    this._commonRelatedObjects = {}
    for (let key in this._relatedObjectsPoly) {
      this._relatedObjectsPoly[key].remove()
    }
  }

  registerOpenPopup() {
    console.warn('registerOpenPopup disabled')
  }

  _revertCoords(coords) {
    let out = []
    if (
      coords.length > 0 &&
      coords[0].length === 2 &&
      !Array.isArray(coords[0][0])
    ) {
      for (let i = 0; i < coords.length; i++) {
        out[i] = [coords[i][1], coords[i][0]]
      }
    } else {
      for (let i = 0; i < coords.length; i++) {
        out[i] = this._revertCoords(coords[i])
      }
    }
    return out
  }

  _parsePolyCoords(v) {
    let coords = null
    try {
      let parsedJson = JSON.parse(v.geojson)
      if (!parsedJson) {
        console.warn('Empty geojson at', v)
        return null
      }
      if (Array.isArray(parsedJson.coordinates)) {
        coords = this._revertCoords(parsedJson.coordinates)

        // Марат, потом сам исправишь это. Если на Татарстане так, это не значит, что так на всех регионах
        if (region.getCurrentRegion() == TATARSTAN) {
          const geojsonType = parsedJson.type
          if (geojsonType === 'MultiPolygon') {
            coords = coords[0]
          }
        }
      }
    } catch (e) {
      throw new Error(e)
    }
    return coords?.length > 0 ? coords : null
  }

  _createModel(v, i) {
    let model = Object.assign({}, v || {})
    delete model.polygon
    model.type = OBJECT.OFFLINE
    if (!model.hasOwnProperty('model')) {
      model.model = model
    }

    if (
      this._polyLegend.popup &&
      this._polyLegend.popup.head &&
      this._polyLegend.popup.fields
    ) {
      model.head = this._polyLegend.popup.head
      model.fields = this._polyLegend.popup.fields
      model._hasPopup = true
    } else if (model.popup && model.popup.head && model.popup.fields) {
      model.head = model.popup.head
      model.fields = model.popup.fields
      model._hasPopup = true
    }
    model.id = model.id || i
    return model
  }

  _parseLegendItem(v, legend) {
    if (!legend.hasOwnProperty('valueKey')) {
      console.error('Unknown valueKey in ', legend)
      return null
    }

    if (legend.valueKey === false) {
      if (
        legend.items &&
        Array.isArray(legend.items) &&
        legend.items.length > 0
      ) {
        return legend.items[0]
      }
      console.error('Not found items[0] in ', legend)
      return null
    }
    if (!v[legend.valueKey]) {
      console.warn('Please check property ' + legend.valueKey + ' value in', v)
    }
    let value = v[legend.valueKey]
    let current = null

    for (let i = 0; i < legend.items.length; i++) {
      if (value > legend.items[i].min) {
        current = legend.items[i]
      } else if (value === -1) {
        current = {
          min: -1,
          style: {
            color: REGION_CONFIG.hasDefaultColorToInfrastructure
              ? COLORS.grey
              : 'transparent',
          },
        }
      } else {
        // eslint-disable-next-line
        current = legend.items.find((item) => item.min === -0)
      }
    }
    return current
  }

  drawPoly() {
    this._relatedObjectsPoly = {}

    this._polyData.forEach((v, i) => {
      let coords = this._parsePolyCoords(v)
      let model = this._createModel(v, i)

      if (model.head === 'Достаточность объектов инфраструктуры') {
        if (!Number(v.sum_power)) {
          v.power_percent = '0'
        } else {
          v.power_percent =
            ((Number(v.sum_power) - Number(v.sum_tonn)) / Number(v.sum_power)) *
            100
        }
        if (v.sum_power === -1) {
          v.power_percent = -1
        }
      }
      let legendItem = this._parseLegendItem(v, this._polyLegend)

      if (coords && legendItem) {
        let { style = {} } = legendItem

        this.drawRelatedPoly(style, model)
        this._polygons[i] = L.polygon(coords, {
          weight: style.weight || model.weight || 1,
          opacity: style.opacity || model.opacity || 0.8,
          color: model.color || style.color,
          fillColor:
            model.color || style.fillColor || style.color || model.fillColor,
          fillOpacity:
            style.fillOpacity ||
            style.opacity ||
            model.fillOpacity ||
            model.opacity ||
            0.4,
          model,
          type: model.type,
          id: model.id,
        }).addTo(this._map)

        if (model._hasPopup === true) {
          this._polygons[i].on('click', () => {
            try {
              this.createPopup(this._polygons[i])
            } catch (e) {
              console.error(e)
            }
          })
        }
      } else {
        console.warn('Unknown model or value or coords empty')
      }
    })
  }

  composeInfrastructurePopupContent(data) {
    let result = `<p>
                   Направление потока: <b>${data.name || ' - '}</b><br>
                   Объект назначения: <b>${data.objectName || ' - '}</b><br>
                  Масса отходов по потоку, тонн.: <b>${
                    data.sizeZonn
                  }</b><br></p>`

    return result
  }

  drawRelatedPoly(style, model) {
    for (let i = 0; i < this._relatedObjects?.length; i++) {
      let coords = this._parsePolyCoords(this._relatedObjects[i])
      const name = this._relatedObjects[i].name_with_type
      const color = style.color || model.color

      if (!this._commonRelatedObjects[name]) {
        if (coords) {
          this._relatedObjectsPoly[i] = L.polygon(coords, {
            weight: style.weight || model.weight || 1,
            opacity: style.opacity || model.opacity || 0.8,
            color,
            fillOpacity:
              style.fillOpacity ||
              style.opacity ||
              model.fillOpacity ||
              model.opacity ||
              0.4,
            model,
            type: model.type,
            id: model.id,
          }).addTo(this._map)
          this._relatedObjectsPoly[i].on('click', () => {
            try {
              const thread = this._relations.find(
                (item) => item.start.name === name
              )
              const sizeZonn = thread.size_tonn
              const objectName = thread.end.name
              const latLng = L.latLng(coords[0][0], coords[0][1])
              const popup = L.popup({
                maxWidth: 1000,
                maxHeight: 1000,
                className: 'tooltip tooltip--top',
                bottomOffset: 50,
              })
                .setLatLng(latLng)
                .setContent(
                  this.composeInfrastructurePopupContent({
                    name,
                    objectName,
                    sizeZonn,
                  })
                )
              this._relatedObjectsPoly[i].bindPopup(popup).openPopup()
            } catch (e) {
              console.error(e)
            }
          })
        }
        this._commonRelatedObjects[name] = {
          ...this._relatedObjects[i],
          infrastructureColor: color,
        }
      } else {
        if (this._commonRelatedObjects[name].infrastructureColor !== color) {
          if (this._relatedObjectsPoly[i]) {
            this._relatedObjectsPoly[i].options.color = COLORS.orange
          }
        }
      }
    }
  }
}
